import { Container } from '@mui/material';
import React from 'react';
import AppBar from '../../app-bar/AppBar';
import { useCheckRole } from '../../auth';
import BackLink from '../../back-link/BackLink';
import QR from '../../qr/QR';

const ScanQR = () => {
  useCheckRole(['Student']);

  return (
    <>
      <AppBar title="Scan QR" />
      <Container
        sx={{ background: 'black', position: 'relative', zIndex: 1, display: { xs: 'inline-block', sm: 'none' } }}
      >
        <BackLink to="/" label="Back to Home" sx={{ color: 'primary.contrastText', my: 2 }} />
      </Container>
      <QR />
    </>
  );
};

export default ScanQR;
